export const netherlandsUniversities = {
  "tu-delft": {
    slug: "tu-delft", country: "netherlands",
    name: "Delft University of Technology", shortName: "TU Delft", flag: "🇳🇱",
    city: "Delft", founded: 1842, qsRank: "#47 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=900&auto=format&fit=crop",
    overview: "Top Dutch university for engineering, robotics, aerospace, and sustainability.",
    tuition: { domestic: "€2,500/yr", international: "€16,000–€22,000/yr" },
    living: "€900–€1,300/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Computer Science", duration: "2 years", language: "English" },
      { name: "MSc Aerospace Engineering", duration: "2 years", language: "English" },
      { name: "MSc Civil Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "€42,000–€68,000", topEmployers: ["ASML","Shell","Philips","Accenture"] },
    intakes: ["September"], istpStudents: 18,
  },

  "university-of-amsterdam": {
    slug: "university-of-amsterdam", country: "netherlands",
    name: "University of Amsterdam", shortName: "UvA", flag: "🇳🇱",
    city: "Amsterdam", founded: 1632, qsRank: "#53 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?q=80&w=900&auto=format&fit=crop",
    overview: "Strong in business, media, psychology, economics, and data science.",
    tuition: { domestic: "€2,500/yr", international: "€12,000–€20,000/yr" },
    living: "€1,000–€1,400/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Data Science", duration: "2 years", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€40,000–€65,000", topEmployers: ["Booking.com","ING","Deloitte"] },
    intakes: ["September","February"], istpStudents: 15,
  },

  "erasmus-university-rotterdam": {
    slug: "erasmus-university-rotterdam", country: "netherlands",
    name: "Erasmus University Rotterdam", shortName: "EUR", flag: "🇳🇱",
    city: "Rotterdam", founded: 1913, qsRank: "#176 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1505761671935-60b3a7427bad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=900&auto=format&fit=crop",
    overview: "Globally known for business, economics, and logistics.",
    tuition: { domestic: "€2,500/yr", international: "€11,000–€19,000/yr" },
    living: "€900–€1,250/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "€45,000–€70,000", topEmployers: ["KPMG","PwC","Unilever"] },
    intakes: ["September"], istpStudents: 12,
  },

  "leiden-university": {
    slug: "leiden-university", country: "netherlands",
    name: "Leiden University", shortName: "Leiden", flag: "🇳🇱",
    city: "Leiden", founded: 1575, qsRank: "#126 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1524041255072-7da0525d6b30?q=80&w=1600&auto=format&fit=crop", 
    campusImg: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=900&auto=format&fit=crop",
    overview: "Historic Dutch university strong in law, politics, and sciences.",
    tuition: { domestic: "€2,500/yr", international: "€13,000–€19,000/yr" },
    living: "€900–€1,200/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [{ name: "MSc Biology", duration: "2 years", language: "English" }],
    placementStats: { rate: "90%", avgSalary: "€38,000–€58,000", topEmployers: ["EU Bodies","Research Labs"] },
    intakes: ["September"], istpStudents: 8,
  },

  "wageningen-university": {
    slug: "wageningen-university", country: "netherlands",
    name: "Wageningen University & Research", shortName: "WUR", flag: "🇳🇱",
    city: "Wageningen", founded: 1918, qsRank: "#155 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?q=80&w=1600&auto=format&fit=crop", 
    campusImg: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=900&auto=format&fit=crop",
    overview: "World leader in agriculture, food science, and sustainability.",
    tuition: { domestic: "€2,500/yr", international: "€16,000–€20,000/yr" },
    living: "€850–€1,100/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [{ name: "MSc Food Technology", duration: "2 years", language: "English" }],
    placementStats: { rate: "94%", avgSalary: "€40,000–€62,000", topEmployers: ["Unilever","Danone"] },
    intakes: ["September"], istpStudents: 6,
  },
};